import type { ReactNode } from 'react';
import { MotionConfig } from 'motion/react';

/**
 * Provider global Framer Motion : `reducedMotion="user"` désactive les
 * animations de transform/layout quand l'OS demande de réduire le mouvement
 * (spec 05 §6). À poser une fois autour de l'app.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
